<style></style>
<template>
	<form method="POST" id="sendInvite" @submit="checkForm">
		<p v-if="errors.length">
			<b>Please correct the following error(s):</b>
			<ul>
				<li v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
			</ul>
		</p>
		<p v-if="successMessage.length">
			<div class="alert alert-success" role="alert" v-for="(message, idx) in successMessage" :key="idx">
				{{message}}
			</div>
		</p>
		<div class="form-row">
			<div class="col-sm-5 first-name">
				<label for="first_name">First Name</label>
				<input type="text" class="form-control" id="first_name" name="first_name" v-model="firstName" required/>
			</div>
			<div class="col-sm-5 offset-sm-1">
				<label for="last_name">Last Name</label>
				<input type="text" class="form-control" id="last_name" name="last_name" v-model="lastName" required/>
			</div>
		</div>
		<div class="form-row">
			<div class="col-sm-5 email">
				<label for="email">Email Address</label>
				<input type="text" class="form-control" id="email" name="email" v-model="email" required/>
			</div>
			<div class="col-sm-5 offset-sm-1">
				<label for="email_confirm">Please reenter the email address.</label>
				<input type="text" class="form-control" id="email_confirmation" name="email_confirmation" v-model="emailConfirmation" required/>
			</div>
		</div>
		<div class="form-row send-invite">
			<button class="btn btn-orange-blue" type="submit">Send Invitation</button>
		</div>
	</form>
</template>
<script>
	export default{
		data(){
			return {
				errors:[],
	            firstName: null,
	            lastName: null,
	            email: null,
	            emailConfirmation: null,
	            successMessage: [],
			}
		},
		methods: {
			checkForm:function(e) {
	            this.errors = [];
	            if(!this.firstName) this.errors.push('First Name is required.')
	            if(!this.lastName) this.errors.push('Last Name is required.')
	            if(!this.email) this.errors.push('Email is required.')
	            if(!this.emailConfirmation) this.errors.push('Email Confirmation is required.')
	            if(this.email !== this.emailConfirmation) this.errors.push("Email fields do not match.");
	            console.log(this.errors)
	            if(this.errors.length){
	            	e.preventDefault()
	            }else{
	            	e.preventDefault()
	            	this.submitForm();
	            } ;
	          },
	          submitForm:function(e){
	          	axios.post('/api/consultants/send-invite', {
	          		'first_name': this.firstName,
	          		'last_name': this.lastName,
	          		'email': this.email,
	          		'email_confirmation': this.emailConfirmation
	          	})
                .then(function (response) {
                	this.successMessage = [response.data]
                	this.firstName = null
	            	this.lastName = null
	            	this.email = null
	            	this.emailConfirmation = null
	            	console.log(this.success)
                }.bind(this))
                .catch(function (error) {
                    console.error(error)
                })
	          }
		},
		mounted: function(){
			console.log(this.successMessage)
		}
	}
</script>